import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-onlinesystem',
  templateUrl: './onlinesystem.component.html',
  styleUrls: ['./onlinesystem.component.css']
})
export class OnlinesystemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
